import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CookieConsent from './components/CookieConsent';

const Landing = lazy(() => import('./components/Landing.jsx'));
const Terms = lazy(() => import('./components/Terms'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const Support = lazy(() => import('./components/Support'));
const DeveloperTerms = lazy(() => import('./components/DeveloperTerms'));
const Developers = lazy(() => import('./components/Developers'));
const Research = lazy(() => import('./components/Research'));
const ResearchArticle = lazy(() => import('./components/ResearchArticle'));

// Public, no-login Pulse Explorer. v3: Home / Perps / Predictions surfaces;
// entity URLs (/explorer/trader/:addr, /explorer/token/:coin) unchanged —
// the sitemap and OG functions depend on them.
const ExplorerPage = lazy(() => import('./explorer/pages/ExplorerPage'));
const PerpsPage = lazy(() => import('./explorer/pages/PerpsPage'));
const PulsePage = lazy(() => import('./explorer/pages/PulsePage'));
const LiquidationsPage = lazy(() => import('./explorer/pages/LiquidationsPage'));
const BuildersPage = lazy(() => import('./explorer/builders/BuildersPage'));
const BuilderProfilePage = lazy(() => import('./explorer/builders/profile/BuilderProfilePage'));
const PredictionsPage = lazy(() => import('./explorer/pages/PredictionsPage'));
const PredictionQuestionPage = lazy(() => import('./explorer/pages/PredictionQuestionPage'));
const TraderPage = lazy(() => import('./explorer/pages/TraderPage'));
const CoinPage = lazy(() => import('./explorer/pages/CoinPage'));

const App = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/developer-terms" element={<DeveloperTerms />} />
        <Route path="/developers" element={<Developers />} />
        <Route path="/markets" element={<Navigate to="/explorer" replace />} />
        <Route path="/research" element={<Research />} />
        <Route path="/research/:slug" element={<ResearchArticle />} />
        {/* Public Pulse Explorer — no auth guard */}
        <Route path="/explorer" element={<ExplorerPage />} />
        <Route path="/explorer/perps" element={<PerpsPage />} />
        {/* The Daily Pulse — frozen morning editions, latest + date-keyed archive */}
        <Route path="/explorer/pulse" element={<PulsePage />} />
        <Route path="/explorer/pulse/:date" element={<PulsePage />} />
        {/* Live 24h liquidation breakdown — value vs realized losses */}
        <Route path="/explorer/liquidations" element={<LiquidationsPage />} />
        {/* Builder codes — revenue, audience and flow attribution */}
        <Route path="/explorer/builders" element={<BuildersPage />} />
        {/* One builder code. The static segment above always out-ranks this
            dynamic one in the router's own scoring, so the tab can never be
            captured by :address — the order here is for a reader, not the
            matcher. */}
        <Route path="/explorer/builders/:address" element={<BuilderProfilePage />} />
        <Route path="/explorer/predictions" element={<PredictionsPage />} />
        <Route path="/explorer/predictions/:qid" element={<PredictionQuestionPage />} />
        <Route path="/explorer/trader/:addr" element={<TraderPage />} />
        <Route path="/explorer/token/:coin" element={<CoinPage />} />
      </Routes>
      {/* Sits outside Routes so the choice can be made from any page,
          including the legal pages it links to. */}
      <CookieConsent />
    </Suspense>
  );
};

export default App;
